module.exports = __webpack_public_path__ + "be4760b794ebc46bf30be23838b3cda6.png";